// extracted by mini-css-extract-plugin
export default {"title":"NotFoundView_title__6glM4"};